import type { ChatBotEntity } from '@common/types/chat-bot.type';

import { createActionGroup, props } from '@ngrx/store';

const ChatBotsActions = createActionGroup({
    source: 'ChatBots/CollectionQuery/API',
    events: {
        'Load Collection Request': props<{ messenger: string }>(),
        'Load Collection Success': props<{ messenger: string; chatBots: ChatBotEntity[] }>(),
        'Load Collection Failure': props<{ messenger: string; error: string }>(),
    },
});

export default ChatBotsActions;
